import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import classNames from "classnames";
import isEmpty from "lodash/isEmpty";

import { PageWrapper, ErrorText, Loader, Alert } from "../../components";
import Actions, { thunks } from "../../redux/modules/admin";
import { validateEmail, validatePhone } from "../../utils/validate";
import BootstrapSwitchButton from "bootstrap-switch-button-react";

const PASSWORD_MIN_LENGTH = 6;
const DEFAULT_COUNTRY_CODE = "91";

class AddAdmin extends Component {
  constructor() {
    super();
    this.state = this.initState();
  }

  componentDidUpdate(prevProps) {
    if (this.props.success && !prevProps.success) {
      this.setState(this.initState());
    }
  }

  componentWillUnmount() {
    this.props.reset();
  }

  initState = () => ({
    form: {
      name: "",
      username: "",
      email: "",
      password: "",
      confirm_password: "",
      phoneNumber: "",
    },
    errors: {},
  });

  onHandleInput = (e) => {
    const {
      target: { name, value },
    } = e;
    this.setState((state) => ({
      form: {
        ...state.form,
        [name]: value,
      },
      errors: {
        [name]: "",
      },
    }));
  };

  saveAdmin = (e) => {
    e.preventDefault();
    const {
      match: {
        params: { userType },
      },
    } = this.props;

    if (userType == 1 && !this.validateForm()) {
      return;
    } else if (
      (userType == 4 || userType == 3) &&
      !this.validateSalesmenForm()
    ) {
      return;
    }
    const { form } = this.state;

    const body = {
      name: form.name,
      phoneNumber: form.phoneNumber,
      countryCode: DEFAULT_COUNTRY_CODE,
      userType: parseInt(userType),
    };
    if (userType == 1) {
      body.password = form.password;
      body.username = form.username;
    }
    this.props.dispatch(thunks.postUser(body));
  };

  validateSalesmenForm = () => {
    const { form } = this.state;
    const errors = {};

    if (!form.name) errors.name = "Required";
    if (!form.phoneNumber) errors.phoneNumber = "Required";
    else if (!validatePhone(form.phoneNumber))
      errors.phoneNumber = "Invalid Phone";
    console.log(errors);
    this.setState({ errors });

    return isEmpty(errors);
  };

  validateForm = () => {
    const { form } = this.state;
    const errors = {};

    if (!form.name) errors.name = "Required";
    if (!form.username) errors.username = "Required";
    if (!form.phoneNumber) errors.phoneNumber = "Required";
    else if (!validatePhone(form.phoneNumber))
      errors.phoneNumber = "Invalid Phone";
    if (!form.password) errors.password = "Required";
    if (!form.confirm_password) errors.confirm_password = "Required";
    else if (form.password !== form.confirm_password) {
      errors.password = "Password mismatch";
      errors.confirm_password = "Password mismatch";
    } else if (form.password.length <= PASSWORD_MIN_LENGTH) {
      errors.password = "Min length is " + PASSWORD_MIN_LENGTH;
    }

    this.setState({ errors });

    return isEmpty(errors);
  };

  onStatusChange = (e) => {
    console.log(e);
  };

  render() {
    const {
      loading,
      error,
      updateProperty,
      match: {
        params: { userType },
      },
    } = this.props;
    const { form, errors } = this.state;
    const type =
      userType == 1 ? "Admin" : userType == 3 ? "Franchise Owner" : `Salesman`;

    return (
      <PageWrapper title={`Add ${type}`}>
        <Loader show={loading} />
        <Alert
          show={!!error}
          onHide={() => updateProperty("error", "")}
          title={"Add " + type}
          message={error}
        />
        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header">Add User</div>
              <div className="card-block">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label
                        className={classNames({ "text-danger": errors.name })}
                      >
                        Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={form.name}
                        maxLength="100"
                        onChange={this.onHandleInput}
                        className={classNames("form-control", {
                          "is-invalid": errors.name,
                        })}
                      />
                      <ErrorText error={errors.name} />
                    </div>
                  </div>
                  {userType == 1 && (
                    <div className="col-md-6">
                      <div className="form-group">
                        <label
                          className={classNames({
                            "text-danger": errors.username,
                          })}
                        >
                          User Name
                        </label>
                        <input
                          type="text"
                          name="username"
                          value={form.username}
                          maxLength="100"
                          onChange={this.onHandleInput}
                          className={classNames("form-control", {
                            "is-invalid": errors.username,
                          })}
                        />
                        <ErrorText error={errors.username} />
                      </div>
                    </div>
                  )}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label
                        className={classNames({
                          "text-danger": errors.phoneNumber,
                        })}
                      >
                        Phone
                      </label>
                      <input
                        type="number"
                        name="phoneNumber"
                        value={form.phoneNumber}
                        maxLength="10"
                        onChange={this.onHandleInput}
                        className={classNames("form-control", {
                          "is-invalid": errors.phoneNumber,
                        })}
                      />
                      <ErrorText error={errors.phoneNumber} />
                    </div>
                  </div>
                  {userType == 1 && (
                    <>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label
                            className={classNames({
                              "text-danger": errors.password,
                            })}
                          >
                            Password
                          </label>
                          <input
                            type="password"
                            name="password"
                            value={form.password}
                            maxLength="100"
                            onChange={this.onHandleInput}
                            className={classNames("form-control", {
                              "is-invalid": errors.password,
                            })}
                          />
                          <ErrorText error={errors.password} />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label
                            className={classNames({
                              "text-danger": errors.confirm_password,
                            })}
                          >
                            Confirm Password
                          </label>
                          <input
                            type="password"
                            name="confirm_password"
                            value={form.confirm_password}
                            maxLength="100"
                            onChange={this.onHandleInput}
                            className={classNames("form-control", {
                              "is-invalid": errors.confirm_password,
                            })}
                          />
                          <ErrorText error={errors.confirm_password} />
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <hr></hr>
                <div className="row">
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Salesman&nbsp;</label>
                      <BootstrapSwitchButton
                        checked={true}
                        name="salesMan"
                        onstyle="success"
                        offstyle="danger"
                        size="xs"
                        onChange={this.onStatusChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Franchise Owner&nbsp;</label>
                      <BootstrapSwitchButton
                        checked={true}
                        name="franchiseOwner"
                        onstyle="success"
                        offstyle="danger"
                        size="xs"
                        onChange={this.onStatusChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Products&nbsp;</label>
                      <BootstrapSwitchButton
                        checked={true}
                        name="products"
                        onstyle="success"
                        offstyle="danger"
                        size="xs"
                        onChange={this.onStatusChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Hot Looks&nbsp;</label>
                      <BootstrapSwitchButton
                        checked={true}
                        name="hotLooks"
                        onstyle="success"
                        offstyle="danger"
                        size="xs"
                        onChange={this.onStatusChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Categories&nbsp;</label>
                      <BootstrapSwitchButton
                        checked={true}
                        name="categories"
                        onstyle="success"
                        offstyle="danger"
                        size="xs"
                        onChange={this.onStatusChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Uploaded Orders&nbsp;</label>
                      <BootstrapSwitchButton
                        checked={true}
                        name="uploadedorders"
                        onstyle="success"
                        offstyle="danger"
                        size="xs"
                        onChange={this.onStatusChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>BroadCasting&nbsp;</label>
                      <BootstrapSwitchButton
                        checked={true}
                        name="broadCasting"
                        onstyle="success"
                        offstyle="danger"
                        size="xs"
                        onChange={this.onStatusChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Banners&nbsp;</label>
                      <BootstrapSwitchButton
                        checked={true}
                        name="banners"
                        onstyle="success"
                        offstyle="danger"
                        size="xs"
                        onChange={this.onStatusChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Orders&nbsp;</label>
                      <BootstrapSwitchButton
                        checked={true}
                        name="orders"
                        onstyle="success"
                        offstyle="danger"
                        size="xs"
                        onChange={this.onStatusChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Delivery&nbsp;</label>
                      <BootstrapSwitchButton
                        checked={true}
                        name="delivery"
                        onstyle="success"
                        offstyle="danger"
                        size="xs"
                        onChange={this.onStatusChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Users&nbsp;</label>
                      <BootstrapSwitchButton
                        checked={true}
                        name="users"
                        onstyle="success"
                        offstyle="danger"
                        size="xs"
                        onChange={this.onStatusChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Version&nbsp;</label>
                      <BootstrapSwitchButton
                        checked={true}
                        name="version"
                        onstyle="success"
                        offstyle="danger"
                        size="xs"
                        onChange={this.onStatusChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Admins&nbsp;</label>
                      <BootstrapSwitchButton
                        checked={true}
                        name="admins"
                        onstyle="success"
                        offstyle="danger"
                        size="xs"
                        onChange={this.onStatusChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-12 d-flex justify-content-end mt-2">
                  <button className="btn btn-primary" onClick={this.saveAdmin}>
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageWrapper>
    );
  }
}

const mapStateToProps = ({ admin: { loading, error, success } }) => ({
  loading,
  error,
  success,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
  reset: bindActionCreators(Actions, dispatch).reset,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddAdmin);
